
export const getRandomString = (length) => {
    const randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
};

export const generateRandomID = () => {
    const timestamp = new Date().getTime();
    const randomString = getRandomString(48); // Adjust the length as needed
    const randomID = `id_${timestamp}_${randomString}`; 
   const extractedString = randomID.split('_')[2]; 
    return extractedString;
   
};